import { collection, getDocs, query, where } from 'firebase/firestore';

import { User } from '../types';
import { db } from '../firebase';

export const fetchPollUsers = async (): Promise<User[]> => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('permissions.conduct_polls', '==', true));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ 
    uid: doc.id, 
    ...doc.data() 
  } as User));
};

export const fetchAllCandidates = async (): Promise<User[]> => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('permissions.conduct_polls', '==', true));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ 
    uid: doc.id, 
    ...doc.data() 
  } as User));
};
